var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#98A2B3",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366 4464 c-175 -42 -319 -189 -355 -362 -16 -75 -16 -3009 0 -3084 37 -179 184 -325 366 -363 102 -22 4264 -22 4366 0 182 38 329 184 366 363 16 75 16 3009 0 3084 -36 175 -180 320 -360 363 -94 22 -4291 21 -4383 -1z m4350 -303 c23 -10 54 -36 70 -57 24 -31 29 -47 29 -94 0 -37 -6 -65 -18 -83 -21 -33 -2133 -1444 -2190 -1464 -24 -8 -53 -11 -75 -7 -43 8 -2182 1430 -2206 1467 -55 83 -18 195 79 238 38 18 124 19 2155 19 2044 0 2116 -1 2156 -19z m-3398 -1273 c554 -369 1030 -682 1057 -694 119 -54 261 -52 382 5 32 15 503 325 1048 688 545 362 996 663 1003 667 10 6 12 -239 10 -1247 l-3 -1254 -29 -37 c-16 -21 -47 -47 -70 -57 -40 -18 -112 -19 -2156 -19 -2044 0 -2116 1 -2156 19 -23 10 -54 36 -70 57 l-29 37 -3 1254 c-1 689 0 1253 3 1253 3 0 458 -302 1013 -672z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailing);
export default __webpack_public_path__ + "static/media/emailing.8dd03248072bf16eef41cd8cbb39f440.svg";
export { ForwardRef as ReactComponent };